// SSH bastions API client. Secrets are never returned; the server only echoes
// "hasSecret" booleans and the public host fingerprint.
import { api } from './api.js';

export const listBastions   = () => api.get('/api/admin/ssh-bastions').then((r) => r.bastions || []);
export const createBastion  = (b) => api.post('/api/admin/ssh-bastions', b);
export const updateBastion  = (id, b) => api.put(`/api/admin/ssh-bastions/${id}`, b);
export const deleteBastion  = (id) => api.delete(`/api/admin/ssh-bastions/${id}`);
export const testBastion    = (id) => api.post(`/api/admin/ssh-bastions/${id}/test`);
